import { api } from '../commonApi';
import { IGetRestaurantResponse } from '../../proto/restaurant/restaurant';

const BASE_RESTAURANT_URL = `/restaurant`;

export const restaurantApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getRestaurantById: builder.query<IGetRestaurantResponse, string>({
			query: (id) => `${BASE_RESTAURANT_URL}/${id}`,
		}),
	}),
});

export const { useGetRestaurantByIdQuery, useLazyGetRestaurantByIdQuery } = restaurantApi;
